export class CoachmarkLocaleItem {
	constructor(public Headline: string, public Text: string) {}
}